/**
 * @module ajaxAPI/cart
 *
 * @description
 * Общие методы для работы с Ajax-отзывами
 */

import _getNodeFromTemplate from '@/ui/ui_ajax-reviews/methods/getNodeFromTemplate';
import _getFieldNodes from '@/ui/ui_ajax-reviews/methods/getFieldNodes';
import _toggleLoadingState from '@/ui/ui_ajax-reviews/methods/toggleLoadingState';
import _renderDate from '@/ui/ui_ajax-reviews/methods/renderDate';
import _imageUrlForPictureSource from '@/ui/ui_ajax-reviews/methods/imageUrlForPictureSource';
import _renderStars from '@/ui/ui_ajax-reviews/methods/renderStars';

export default {
  _getNodeFromTemplate,
  _getFieldNodes,
  _toggleLoadingState,
  _imageUrlForPictureSource,
  _renderDate,
  _renderStars,
};
